import { ColorCode } from '@vinted/web-ui'

const colorCodeHexMap: Partial<Record<ColorCode, string>> = {
  // primary
  [ColorCode.Primary]: '#007782',
  [ColorCode.PrimaryMedium]: '#86CDCF',
  [ColorCode.PrimaryDark]: '#004654',
  // success
  [ColorCode.Success]: '#28865A',
  // expose
  [ColorCode.Expose]: '#F9BB42',
  // warning
  [ColorCode.Warning]: '#D04555',
  // grayscale
  [ColorCode.GreyscaleLevel1]: '#15191A',
  [ColorCode.GreyscaleLevel2]: '#5A6566',
  [ColorCode.GreyscaleLevel3]: '#B6BEBF',
  [ColorCode.GreyscaleLevel4]: '#E1E6E6',
  [ColorCode.GreyscaleLevel5]: '#EDF2F2',
  [ColorCode.GreyscaleLevel6]: '#FFFFFF',
}

export function colorCodeToHex(code: ColorCode): string | undefined {
  return colorCodeHexMap[code]
}
